/**
 * Block: annual-reports
 *
 * Custom year-picker dropdown that swaps which year of report data is
 * displayed and which download button is active. The block can appear
 * multiple times on a page, so we self-scope to each section.
 */

function initBlock(section) {
    const customSelect = section.querySelector('.annual-reports__custom-select');
    const selectedOption = section.querySelector('.annual-reports__selected-option');
    const options = section.querySelectorAll('.annual-reports__select-option');
    const dataWrappers = section.querySelectorAll('.annual-reports__data-wrapper');
    const downloadButtons = section.querySelectorAll('.annual-reports__download-button');

    if (!customSelect || !selectedOption || !options.length) return;

    // Toggle dropdown open/closed
    customSelect.addEventListener('click', () => {
        customSelect.classList.toggle('options-active');
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
        if (!customSelect.contains(e.target)) {
            customSelect.classList.remove('options-active');
        }
    });

    // Year option selection
    options.forEach((option) => {
        option.addEventListener('click', (e) => {
            e.stopPropagation();
            const target = option.textContent.trim();
            selectedOption.textContent = target;

            dataWrappers.forEach((item) => {
                item.classList.toggle('active', item.id === target);
            });

            downloadButtons.forEach((item) => {
                item.classList.toggle('active', item.id === target);
            });

            customSelect.classList.remove('options-active');
        });
    });
}

export function init() {
    document.querySelectorAll('section.annual-reports').forEach(initBlock);
}
